<template>
    <form class="product-purchased">
        <div class="product-purchased-body">
            <span class="summary-label">
                {{ LABEL_VALUES.summary }}
            </span>
            <p class="summary-text">
                {{ LABEL_VALUES.message }}
            </p>

            <ds-multiselect
                :key="purchaseTypeKey"
                v-model="selectedPurchaseType"
                help-text-prop="additional"
                :searchable="isFs41489Enabled"
                :placeholder="LABEL_VALUES.selectPurchaseType_placeholder"
                bind-value-only
                :options="productPurchasesOptions"
                @input="cleanOptions"
            />

            <div v-if="isWebForm && !keapApp">
                <ds-multiselect
                    id="orderForm-selection"
                    :key="webFormKeyId"
                    v-model="selectedOrderForm"
                    multiple
                    searchable
                    :placeholder="LABEL_VALUES.selectOrderForm_placeholder"
                    bind-value-only
                    :options="orderFormOptions"
                />
            </div>
            <div v-if="isProduct">
                <CustomMultiselect
                    id="product-selection"
                    :key="productKeyIds"
                    v-model="selectedProduct"
                    categorized
                    multiple
                    searchable
                    :placeholder="LABEL_VALUES.selectProduct_placeholder"
                    bind-value-only
                    custom-chip-label
                    help-text
                    help-text-prop="subText"
                    filter-categories
                    remove-selected-categories
                    :options="productsOptions"
                />
            </div>

            <div v-if="isProductCategory">
                <ds-multiselect
                    id="productCategory-selection"
                    :key="productCategoryKeyId"
                    v-model="selectedProductCategory"
                    multiple
                    searchable
                    :placeholder="LABEL_VALUES.selectProductCategory_placeholder"
                    bind-value-only
                    :options="categoriesOptions"
                />
            </div>
            <div v-if="isNotOrderForm">
                <div class="summary-body">
                    {{ LABEL_VALUES.and }}
                </div>

                <ds-multiselect
                    id="paymentType-selection"
                    :key="selectPaymentTypeKey"
                    v-model="selectedPaymentType"
                    multiple
                    searchable
                    bind-value-only
                    :placeholder="LABEL_VALUES.selectPaymentType_placeholder"
                    :options="paymentsTypeOptions"
                />
            </div>
        </div>
        <ds-icon-button
            :aria-label="$options.MESSAGE_CONSTANTS.close"
            class="closemodal"
            @click="closeModal"
        >
            <ds-icon name="x" />
        </ds-icon-button>
        <ds-filled-button
            class="savebutton"
            :disabled="disableSave"
            @click="saveCell"
        >
            {{ LABEL_VALUES.save }}
        </ds-filled-button>
    </form>
</template>
<script>
import CustomMultiselect from '@/components/shared/CustomMultiselect';

export const MESSAGE_CONSTANTS = {
    credit_card: 'Credit Card',
    include_invoices: 'Include $0 invoices',
    close: 'Close modal',
};
export default {
    MESSAGE_CONSTANTS,
    components: {
        CustomMultiselect,
    },
    props: {
        vueComponentId: String,
        orderFormOptionsString: String,
        productsOptionsString: String,
        categoryOptionsString: String,
        paymentsTypeOptionsString: String,
        isKeapAppString: String,
        isFs41489Enabled: Boolean,
    },
    data() {
        return {
            jgraph: {},
            cellInfo: {},
            cellValue: {},
            purchaseOptionId: null,
            saveCellOptions: {},
            selectedPurchaseType: null,
            selectedOrderForm: [],
            selectedProduct: [],
            selectedProductCategory: [],
            selectedPaymentType: [],
            webFormKeyId: 'webFormKeyMS-0',
            productKeyIds: 'productKeyMS-0',
            productCategoryKeyId: 'categoryProductKeyMS-0',
            selectPaymentTypeKey: 'selectPaymentTypeKeyMS-0',
            purchaseTypeKey: 'purchaseTypeKeyMS-0',
            orderFormOptions: JSON.parse(this.orderFormOptionsString),
            productsOptions: JSON.parse(this.productsOptionsString),
            categoriesOptions: JSON.parse(this.categoryOptionsString),
            paymentsTypeOptions: JSON.parse(this.paymentsTypeOptionsString),
            keapApp: JSON.parse(this.isKeapAppString),
            options: MESSAGE_CONSTANTS.options,
            LABEL_VALUES: {
                summary: '',
                message: '',
                selectPurchaseType_placeholder: '',
                selectOrderForm_placeholder: '',
                selectProduct_placeholder: '',
                selectProductCategory_placeholder: '',
                selectPaymentType_placeholder: '',
                and: '',
                save: '',
            },
            productPurchases_Options: [
                { value: 'orderForm', label: '', additional: 'When a purchase is made from a specific order form' },
                { value: 'product', label: '', additional: 'When a specific product is purchased' },
                { value: 'category', label: '', additional: 'When a product is purchased from a specific category' },
                { value: 'all', label: '', additional: 'When any purchase is made' },
            ],
            productPurchasesOptions: {},
        };
    },
    created() {
        this.LABEL_VALUES.summary = window.keapI18nMap['campaign.product.purchased.summary'];
        this.LABEL_VALUES.message = window.keapI18nMap['campaign.product.purchased.message'];
        this.LABEL_VALUES.selectPurchaseType_placeholder = window.keapI18nMap['campaign.product.purchased.selectPurchaseType_placeholder'];
        this.LABEL_VALUES.selectOrderForm_placeholder = window.keapI18nMap['campaign.product.purchased.selectOrderForm_placeholder'];
        this.LABEL_VALUES.selectPaymentType_placeholder = window.keapI18nMap['campaign.product.purchased.selectPaymentType_placeholder'];
        this.LABEL_VALUES.selectProduct_placeholder = window.keapI18nMap['campaign.product.purchased.selectProduct_placeholder'];
        this.LABEL_VALUES.selectProductCategory_placeholder = window.keapI18nMap['campaign.product.purchased.selectProductCategory_placeholder'];
        this.LABEL_VALUES.and = window.keapI18nMap['campaign.product.purchased.and'];
        this.LABEL_VALUES.save = window.keapI18nMap['campaign.landing.page.save'];
        this.productPurchases_Options[0].label = window.keapI18nMap['campaign.product.purchased.productPurchases_options_one'];
        this.productPurchases_Options[1].label = window.keapI18nMap['campaign.product.purchased.productPurchases_options_two'];
        this.productPurchases_Options[2].label = window.keapI18nMap['campaign.product.purchased.productPurchases_options_three'];
        this.productPurchases_Options[3].label = window.keapI18nMap['campaign.product.purchased.productPurchases_options_four'];
        this.productPurchasesOptions = this.productPurchases_Options;
    },
    mounted () {
        document.getElementById(this.vueComponentId).addEventListener('loadCellValueObject', this.loadCellValueObject);
        this.hideOrderForm();
    },
    beforeDestroy () {
        document.getElementById(this.vueComponentId).removeEventListener('loadCellValueObject');
    },
    computed: {
        isWebForm() {
            this.selectedPurchaseType;

            return this.selectedPurchaseType === 'orderForm';
        },
        isProduct() {
            this.selectedPurchaseType;

            return this.selectedPurchaseType === 'product';
        },
        isProductCategory() {
            this.selectedPurchaseType;

            return this.selectedPurchaseType === 'category';
        },
        isAnyPurchase() {
            this.selectedPurchaseType;

            return this.selectedPurchaseType === 'all';
        },
        isNotOrderForm() {
            this.selectedPurchaseType;

            return this.selectedPurchaseType !== 'orderForm';
        },
        disableSave() {
            let disable = false;

            if (!this.selectedPurchaseType) return true;

            if (this.isWebForm) {
                disable = this.selectedOrderForm.length === 0;
            }

            if (this.isProduct) {
                disable = this.selectedProduct.length === 0 || this.selectedPaymentType.length === 0;
            }

            if (this.isProductCategory) {
                disable = this.selectedProductCategory.length === 0 || this.selectedPaymentType.length === 0;
            }

            if (this.isAnyPurchase) {
                disable = this.selectedPaymentType.length === 0;
            }

            return disable;
        },
    },
    methods: {
        hideOrderForm() {
            if (this.keapApp) {
                const disabled = ['orderForm', 'category'];

                this.productPurchasesOptions = this.productPurchasesOptions.filter((option) => {
                    return !disabled.includes(option.value);
                });
            }
        },
        loadDefaultPaymentTypes() {
            const defaultPaymentsTypes = [];

            for (let index = 0; index < this.paymentsTypeOptions.length; index++) {
                const paymentsType = this.paymentsTypeOptions[index].value;

                if (paymentsType === MESSAGE_CONSTANTS.credit_card || paymentsType === MESSAGE_CONSTANTS.include_invoices) {
                    defaultPaymentsTypes.push(paymentsType);
                }
            }

            this.selectedPaymentType = defaultPaymentsTypes;
        },
        loadCellValueObject (event) {
            this.$nextTick(() => {
                const purchaseIdValues = [];
                const purchaseIdString = event.detail.cellValue.purchaseId;
                const paymentTypeValues = event.detail.cellValue.paymentTypes;
                const purchaseTypeValue = event.detail.cellValue.purchaseType;

                this.purchaseOptionId = event.detail.cellValue.purchaseOption;
                this.jgraph = event.detail.jgraph;
                this.cellInfo = event.detail.cellInfo;
                this.cellValue = event.detail.cellValue;
                this.saveCellOptions = event.detail.options;
                this.saveCellOptions.saver = undefined;

                if (!paymentTypeValues) {
                    this.loadDefaultPaymentTypes();
                } else {
                    const paymentTypeArray = paymentTypeValues.split(',');

                    this.selectedPaymentType = paymentTypeArray;
                }

                if (Array.isArray(purchaseIdString)) {
                    for (let index = 0; index < purchaseIdString.length; index++) {
                        const purchaseValue = purchaseIdString[index].toString();

                        purchaseIdString[index] = purchaseValue.replace('L', '');

                        if (purchaseTypeValue === 'product') {
                            if (purchaseValue.includes(':')) {
                                purchaseIdValues[index] = purchaseValue;
                            } else if (this.hasGroups(purchaseValue)) {
                                purchaseIdValues[index] = this.getPurchaseOptionId(purchaseValue);
                            } else {
                                purchaseIdValues[index] = purchaseValue;
                            }
                        } else {
                            purchaseIdValues[index] = purchaseValue;
                        }
                    }
                } else {
                    let purchaseValueId = purchaseIdString;

                    if (purchaseValueId) {
                        purchaseValueId = purchaseIdString.toString();
                        purchaseValueId = purchaseValueId.replace('L', '');
                    }

                    if (purchaseTypeValue === 'product') {
                        if (purchaseValueId.includes(':')) {
                            purchaseIdValues.push(purchaseValueId);
                        } else if (this.hasGroups(purchaseValueId)) {
                            purchaseIdValues.push(this.getPurchaseOptionId(purchaseValueId));
                        } else {
                            purchaseIdValues.push(purchaseValueId);
                        }
                    } else {
                        purchaseIdValues.push(purchaseValueId);
                    }
                }

                this.selectedPurchaseType = event.detail.cellValue.purchaseType;

                if (this.isWebForm) {
                    if (this.keapApp) {
                        this.selectedPurchaseType = 'all';
                        this.loadDefaultPaymentTypes();
                    } else {
                        this.selectedOrderForm = purchaseIdValues.map((i) => Number(i));
                    }
                }

                if (this.isProduct) this.selectedProduct = purchaseIdValues;
                if (this.isProductCategory) this.selectedProductCategory = purchaseIdValues.map((i) => Number(i));

                this.webFormKeyId = 'webFormKeyMS';
                this.productKeyIds = 'productKeyMS';
                this.productCategoryKeyId = 'categoryProductKeyMS';
                this.selectPaymentTypeKey = 'selectPaymentTypeKeyMS';
                this.purchaseTypeKey = 'purchaseTypeKeyMS';
            });
        },
        saveCell() {
            const purchaseId = this.getPurchaseId();
            const purchaseIdsValues = [];
            const purchaseOptionValues = [];

            if (Array.isArray(purchaseId)) {
                for (let index = 0; index < purchaseId.length; index++) {
                    const purchaseValue = purchaseId[index].toString();

                    if (purchaseValue.includes(':')) {
                        const op = purchaseValue.split(':');

                        purchaseIdsValues.push(purchaseValue);
                        purchaseOptionValues.push(op[1]);
                    } else {
                        purchaseIdsValues.push(purchaseId[index]);
                    }
                }
                this.cellValue.purchaseId = purchaseIdsValues;
                this.cellValue.eventId = purchaseIdsValues;

                if (purchaseOptionValues) {
                    this.cellValue.purchaseOption = purchaseOptionValues;
                } else {
                    this.cellValue.purchaseOption = 0;
                }
            } else {
                this.cellValue.purchaseId = purchaseId;
                this.cellValue.eventId = purchaseId;

                if (this.purchaseOptionId) {
                    this.cellValue.purchaseOption = this.purchaseOptionId;
                } else {
                    this.cellValue.purchaseOption = 0;
                }
            }

            this.cellValue.purchaseType = this.selectedPurchaseType;

            if (this.isWebForm) {
                this.cellValue.paymentTypes = this.loadDefaultPaymentTypes();
            } else {
                this.cellValue.paymentTypes = this.selectedPaymentType.toString();
            }

            const eventData = {
                detail: {
                    cellValue: this.cellValue,
                    cellInfo: this.cellInfo,
                    jgraph: this.jgraph,
                    options: this.saveCellOptions,
                },
            };

            this.$emit('save-cell', eventData);

            this.closeModal();
        },

        getPurchaseId() {
            if (this.isWebForm) return this.selectedOrderForm;
            if (this.isProduct) return this.selectedProduct;
            if (this.isProductCategory) return this.selectedProductCategory;

            return 0;
        },

        getPurchaseOptionId(purchaseValue) {
            return purchaseValue.concat(':').concat(this.purchaseOptionId);
        },

        hasGroups(purchaseValueId) {
            const option = this.productsOptions.filter((opt) => opt.category.value === purchaseValueId);

            return option.length > 0 && option[0].groups !== undefined;
        },

        closeModal() {
            document.querySelector('span.container-close').click();
        },

        cleanOptions() {
            if (!this.isWebForm) {
                this.selectedOrderForm = [];
            }

            if (!this.isProduct) {
                this.selectedProduct = [];
            }

            if (!this.isProductCategory) {
                this.selectedProductCategory = [];
            }
        },
    },
};
</script>
<style lang="scss">
.product-purchased-body .ds-card {
    width: 100%;
    background-color: #f0f0f0;
}
div.dropdown-menu.open > div.menu {
    height: min-content;
}
svg.icon {
    width: 48px;
    padding-left: 0px;
}
.modal-footer {
    visibility: hidden;
    display: none;
}
div#lightbox {
    display: grid;
    grid-template-areas: 'containerclose headertext savebutton' 'lightboxcontent lightboxcontent lightboxcontent';
    grid-template-columns: 6% 80% 14%;
    background-color: #fff;
    width: 640px !important;
    border-radius: 12px;
}
div#lightbox > div#lightbox-content {
    grid-area: lightboxcontent;
    border-top: 1px solid #DDDDDD;
}
div#lightbox > div.hd {
    grid-area: headertext;
    background-color: #fff;
    border-bottom: none;
    height: 56px;
}
form > .closemodal {
    grid-area: containerclose;
    background-color: #fff;
    padding: 0;
    margin: 0;
    left: 20px;
    width: auto;
    height: auto;
    position: absolute;
    top: 12px;
    left: 12px;
}
form > .savebutton {
    grid-area: savebutton;
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
    color: var(--text-color, white);
}
svg.icon {
    width: 48px;
    padding-left: 0px;
}
span.container-close {
    visibility: hidden;
}
span.summary-label {
    color: rgba(0, 0, 0, 0.4);
}
p.summary-text {
    margin-top: 4px;
    margin-bottom: 24px;
}
.dropdown-menu.open {
    border: none;
    padding: 0px;
}
</style>

<style lang="scss" scoped>
.product-purchased {
    width:      100%;
    height:     fit-content;
    margin:     0;
    padding:    0;
}
.product-purchased-header {
    display:                grid;
    width:                  100%;
    padding:                12px;
    grid-template-columns:  24px 485px 65px;
    border-bottom:          1px solid rgba(0,0,0,.12);
}
.product-purchased-header > h4 {
    margin: 12px 0 0 16px;
}
.product-purchased-body {
    width:  100%;
    padding:    4px 24px 16px 24px;
}
.summary-header {
    margin-top:     8px;
    color:          #69697b;
    font-size:      12px;
    font-weight:    400;
}
.summary-body {
    margin-bottom: 24px;
    font-size: 16px;
}
</style>
